import { Injectable } from '@angular/core';

import { fromEvent } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class WindowRef {
  public get nativeWindow(): Window {
    return window;
  }

  public resize$ = fromEvent(this.nativeWindow, 'resize').pipe(share());

  public open(url: string, windowName: string = '_blank'): Window {
    return this.nativeWindow.open(url, windowName)!;
  }
}
